import PaIcon from "../assets/pa-icon.svg"

const Navbar = () => {
    return (
        <header className="header">
            <div className="logo">
                <img src={PaIcon} alt="PA Logo" />
            </div>
            <nav className="nav">
                <a href="/startups">Startups</a>
                <a href="/advisors">Advisors</a>
                <a href="/investors">Investors</a>
                <a href="/community">Community</a>
            </nav>
            <button
                className="apply-btn"
                onClick={() => window.open("https://forms.gle/2ewkTW56QUAMHY1g9", "_blank")}
            >
                Apply Now
            </button>
        </header>
    );
};

export default Navbar;